import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TyroService } from './tyro.service';

@NgModule({
  imports: [CommonModule],
  providers: [TyroService],
})
export class NgTyroModule {}
